import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { resetOrganizationGroups } from 'redux/slices/organization'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function CreateGroup() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const userId = useSelector((state) => state.user.id)
    const organizationId = useSelector((state) => state.user.organizationId)

    const [groupName, setGroupName] = useState('')
    const [groupDescription, setGroupDescription] = useState('')
    const [createLoading, setCreateLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const HandleGroupFormChange = (key, value) => {
    
        setErrorMessage('')

        switch (key) {
            case 'groupName':
                setGroupName(value)
                break
            case 'groupDescription':
                setGroupDescription(value)
                break
        }
    
    }

    const OnCreateGroup = async () => {

        if (groupName.length === 0) {
            setErrorMessage('Group name is required!')
            return
        }

        setCreateLoading(true)

        const jsonBody = {
            userId: userId,
            organizationId: organizationId,
            groupName: groupName,
            groupDescription: groupDescription,
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('REPORTING', 'POST', '/create_group', jsonBody)

        // console.log(result)

        setCreateLoading(false)

        if (result.data.status === 'failure') {
            console.error(result)
            setErrorMessage(result.data.message)
            return
        }

        dispatch(resetOrganizationGroups())

        navigate('/groups')

    }

    return (
        <ScreenFrame>
            <div className='max-w-2xl mx-auto space-y-4'>
                <div className="w-full gap-4 flex items-center">
                    <h1>Create Group</h1>
                </div>

                <ContentFrame>
                    <div className="w-full p-6 space-y-6">
                        <div>
                            <label htmlFor="group-name" className="block text-sm font-medium leading-6 text-gray-900">
                                Group Name*
                            </label>

                            <div className="mt-2">
                                <input
                                    id="group-name"
                                    name="group-name"
                                    type="text"
                                    placeholder="Enter text here"
                                    className="block w-full rounded-lg border border-gray-400 px-4 py-2.5"
                                    value={groupName}
                                    onChange={(e) => HandleGroupFormChange('groupName', e.target.value)}
                                    maxLength={255}
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="group-description" className="block text-sm font-medium leading-6 text-gray-900">
                                Group Description
                            </label>

                            <div className="mt-2">
                                <textarea
                                    id="group-description"
                                    name="group-description"
                                    placeholder="Enter text here"
                                    className="block w-full rounded-lg border border-gray-400 px-4 py-2.5 h-40"
                                    value={groupDescription}
                                    onChange={(e) => HandleGroupFormChange('groupDescription', e.target.value)}
                                    maxLength={255}
                                />
                            </div>
                        </div>

                        <BrandColorButton
                            text="Create"
                            action={OnCreateGroup}
                            isLoading={createLoading}
                        />

                        {errorMessage !== '' && 
                            <div className='text-center text-sm text-red-500 font-bold'>{errorMessage}
                            </div>
                        }
                    </div>
                </ContentFrame>
            </div>
        </ScreenFrame>
    )
}